export const getFirstAndLastFocusableElement = (
	root: Element | HTMLElement | ShadowRoot
): { first: HTMLElement; last: HTMLElement } => {
	if (root) {
		const focusableElements = Array.from<HTMLElement>(
			root.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')
		).filter(el => !el.hasAttribute('disabled') && el.offsetParent)

		if (focusableElements.length > 0) {
			return { first: focusableElements[0], last: focusableElements[focusableElements.length - 1] }
		}
	}
	return { first: null, last: null }
}
